<template>
    <v-form name="set-refuse-form">
        <div class="grid"
             style="margin-top:5px">
            <FormInputText fieldName="refuse_reason"
                           label="Refuse reason"
                           validation="required"
                           v-model:field="refuse_reason" />
        </div>

        <div class="grid"
             style="margin-top:20px">
            <Button @click.stop="setRefuse"
                    :class="buttonClass('green')">
                <template class="flex items-center gap-1"><i class="fa-regular fa-circle-xmark"></i><span>{{ __('Refuse') }}</span></template>
            </Button>

            <Button @click="cancel"
                    :class="buttonClass('gray')">
                <template class="flex items-center gap-1"><i class="fa-regular fa-trash-can"></i><span>{{ __('Cancel') }}</span></template>
            </Button>
        </div>
    </v-form>
</template>

<script setup>
import { ref } from 'vue'
import { usePage } from "@inertiajs/vue3";
import Button from 'primevue/button';
import FormInputText from '@crud/FormInputText.vue'
import { __, getFromRoute, screenMessage, buttonClass } from '@pages/Helper/utils.js'
import { validation } from '@pages/Helper/crud_utils.js'

// -----------------------------------------------------
const props = defineProps({
    leadData: Object,
    formProps: Object,
})
const page = usePage()

const isSetRefuseModalOpen = defineModel('isSetRefuseModalOpen')
const refuse_reason = ref('')

// -----------------------------------------------------

const cancel = () => {
    isSetRefuseModalOpen.value = false
}
// -----------------------------------------------------

const setRefuse = async () => {
    const formData = {
        'id': props.leadData.id,
        'status_symbol': 'SYM_REFUSED',
        'refuse_reason': refuse_reason.value
    }

    if (validation(formData, 'set-refuse-form')) {
        const response = await getFromRoute('lead-status-set', formData, 'post');
        screenMessage({ ...response })

        isSetRefuseModalOpen.value = false
        props.formProps.closeModal()
        props.formProps.getLazyData()
    }
}
// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
